import { Check, Star } from 'lucide-react';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import useSearchParamActions from '@/customHooks/useSearchParamActions';
import { useGetPartnersQuery } from '../partner/partner.api.slice';
import { IPartnerData } from '../partner/partner';

function PartnerFilter({ submenu }: { submenu?: boolean }) {
  const { appendSearchParam, removeSearchParam, getSearchParam } =
    useSearchParamActions();

  const { data: partnerData } = useGetPartnersQuery();

  const currentPartnerUserId = getSearchParam('partner');

  if (!partnerData?.length) return null;

  return (
    <FilterMenu label="Partners" submenu={submenu}>
      <DropdownMenuItem onClick={() => removeSearchParam('partner')}>
        {!currentPartnerUserId && <Check className="mr-2 h-4 w-4" />}
        All
      </DropdownMenuItem>
      {partnerData
        .filter(
          (partner: IPartnerData) => partner.user !== currentPartnerUserId
        )
        .map((partner: IPartnerData) => (
          <DropdownMenuItem
            key={partner._id}
            onClick={() => appendSearchParam('partner', partner.user)}
          >
            <div
              className="flex h-6 w-6 items-center justify-center rounded-full"
              style={{ backgroundColor: partner?.color }}
            >
              <Star className="h-1 w-1 text-white" fill="white" />
            </div>
            {partner.name}
          </DropdownMenuItem>
        ))}
    </FilterMenu>
  );
}

export default PartnerFilter;
